export default __webpack_public_path__ + "static/media/item-list-review-grey.aed6b0d5.svg";